import { onMounted, onUnmounted } from 'vue'
import { useAnalytics } from '@/composables/useAnalytics'
import { getBuyFlowController } from '@/features/crosschain-buy/buy-flow/controller'
import { useCrosschainBuy } from './useCrosschainBuy'
import { usePhantomResumeOnMount } from '@/features/crosschain-buy/wallets/phantom-deeplink/bindings'
import { useWalletBindings } from '@/features/crosschain-buy/wallets/bindings'
import { useWallets } from '@/features/crosschain-buy/wallets/use-wallets'
import { useExecutionPollingBindings } from './useExecutionPollingBindings'

export function useCrosschainBuyRoot(): void {
  const controller = getBuyFlowController()
  const buy = useCrosschainBuy()
  const wallets = useWallets()
  const { trackEvent } = useAnalytics()

  onMounted(() => {
    controller.mountUi((eventName, payload) => {
      trackEvent(eventName, payload ?? {})
    })
  })

  useWalletBindings({
    invalidateRouteContext: buy.invalidateRouteContext,
    syncQuoteForCurrentSelection: buy.syncQuoteForCurrentSelection,
  })

  usePhantomResumeOnMount({
    openFromCta: buy.openFromCta,
    connectSolanaWallet: wallets.connectSolana,
    trackEvent,
  })
  useExecutionPollingBindings()

  onUnmounted(() => {
    controller.unmountUi()
  })
}
